// extracted by mini-css-extract-plugin
export default {"rowHighlightTop":"TableDataRow_rowHighlightTop__H2HZc","rowHighlightBottom":"TableDataRow_rowHighlightBottom__LG9Y+","innerCell":"TableDataRow_innerCell__XCbJl"};